import './App.scss';
import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Route, Routes, useNavigate, useSearchParams } from 'react-router-dom';

import { Welcome } from './vista/welcome';
import { version, Test, AppConfig } from '@essenza/core';
import { AppRoot } from '@essenza/react';
import { AppSchema } from './schema';
import { MainLayout } from './layout/MainLayout';
import { JobVista } from './vista/JobVista';
import { CompanyFormVista } from './vista/CompanyFormVista';
import { JobFormVista } from './vista/JobFormVista';
import { JobListVista } from './vista/JobListVista';
import { CandiateVista } from './vista/CandidateVista';
import { AllCandiateVista } from './vista/AllCandidateVista';
import { AreaModel, ContractModel, PlaceModel, RoleModel, SkillModel } from './models/DBModel';
import { InsertCompanyVista } from './vista/InsertCompanyVista';
import { ContactVista } from './vista/ContactVista';
import { ProfileVista } from './vista/ProfileVista';
import { NotificationVista } from './vista/NotifictionVista';
import { JobCloseVista } from './vista/JobCloseVista';
import { LoginVista } from './vista/profile/LoginVista';
import { RecoverVista } from './vista/profile/RecoverVista';
import { FirstAccessVista } from './vista/profile/FirstAccessVista';

/**
 * 
 * @param {VistaApp} app 
 */
function initApp(app) {
  console.log("INIT APP", app);
  AppConfig.serviceRoute = "service/app/"
  //VistaJS.DEVELOPMENT = true;
  app.model.read(SkillModel, m=>m.list());
  app.model.read(RoleModel, m=>m.list());
  app.model.read(PlaceModel, m=>m.list());
  app.model.read(ContractModel, m=>m.list());
  app.model.read(AreaModel, m => m.list());
  return null;
}

/**
 * 
 * @param {VistaApp} app 
 */
function onlogin(app) {
  console.log("ON LOGIN", app);
  app.navigate("/offerta")
}

function AppController(c) {
  c.skin = App;
  c.command = null;
}

function App() {
  console.log("START VISTA APP", version, Test);
  const nav = useNavigate();
  const [qp] = useSearchParams();
  const token = useRef();
  useEffect(() => {
    console.log("TEST EFFECT", token);
  }, []);
  //https://network.ssati.it/
  //https://localhost:44370/
  //http://networkssati.iconsultant.it/
  return (
    <>
      <AppRoot token={token} init={initApp} control={AppController} navigator={nav} qp={qp} onlogin={onlogin} basename="/app" baseurl="https://network.ssati.it/" schema={AppSchema}>
        <Routes>
          <Route path="/" element={<MainLayout token={token} />}>
            <Route path="offerte" element={<JobListVista />} />
            <Route path="offerta" element={<JobFormVista />} />
            <Route path="candidati" element={<CandiateVista />} />
            <Route path="allcandidati" element={<AllCandiateVista />} />
            <Route path="chiuse" element={<JobCloseVista />} />
            <Route path="profile" element={<ProfileVista />} />
            <Route path="contatto" element={<ContactVista />} />
            <Route path="notifications" element={<NotificationVista />} />
          </Route>
          <Route index element={<Welcome token={token} />} />
          <Route path="login" element={<LoginVista />} />
          <Route path="loginrec" element={<RecoverVista />} />
          <Route path="primoaccesso" element={<FirstAccessVista />} />
        </Routes>
      </AppRoot>
      {/* <PopUp /> */}

      {/* <Routes>
          {breakpoint.md.active
            ? <Route path="/" element={<MainLayout model={AppModel} />}>
              <Route index element={<HomeVista />} />
              <Route path="stazioni" element={<StationVista />} />
              <Route path="satellite" element={<SatelliteVista />} />
              <Route path="bollettino" element={<BollettinoVista />} />
            </Route>
            :
            <Route path="/" element={<MobileLayout model={AppModel} />}>
              <Route index element={home} />
              <Route path="mobilemenu" element={<MobileMenuVista />} />
              <Route path="mobilestation" element={<MobileStationVista />} />
              <Route path="mobilew" element={<WarningView />} />
            </Route>
          }
          <Route path="mobilechannel" element={<MobileChannelVista />} />
        </Routes> */}
    </>
  );
}

export default App;
